var mobileHandles = document.querySelectorAll('.menu__handle');

if (mobileHandles.length) {
  mobileHandles.forEach(function (mobileHandle, i) {
    mobileHandle.addEventListener('click', function (event) {
      event.stopPropagation(); // document.documentElement.classList.toggle('menu--opened');

      document.querySelectorAll('.menu__wrapper').forEach(function (menu, j) {
        if (i !== j) {
          menu.classList.remove('opened');
        }

        document.querySelectorAll('div.profile').forEach(function (profile) {
          profile.classList.remove('profile--opened');
        });
      });
      var mobileMenu = mobileHandle.closest('.menu__wrapper');
      mobileMenu.classList.toggle('opened');

      if (mobileMenu.classList.contains('opened')) {
        document.documentElement.classList.add('menu--opened');
      } else {
        document.documentElement.classList.remove('menu--opened');
      }
    });
  });
}